import hoistNonReactStatic from 'hoist-non-react-statics';
import React, { useContext } from 'react';
import { UniversalContext } from '../../../_universal';
import { SchedulingSessionStateContext } from '../SchedulingSessionState';

/**
 * A higher order component for getting the widget settings from the context as well as the universalContext.
 */
export default function withCustomContextsComponent(WrappedComponent) {
  const componentName = WrappedComponent.displayName || WrappedComponent.name;
  const WithCustomContexts = (props) => {
    const universalContext = useContext(UniversalContext);

    const {
      widgetSettings,
      screenerStatus,
      prefillToken,
      prefillData,
      trackerData,
      widgetSessionOpenedTracked,
      scheduleRequestAttemptData,
      setScheduleRequestAttemptData,
    } = useContext(SchedulingSessionStateContext);
    return (
      <WrappedComponent
        universalContext={universalContext}
        widgetSettings={widgetSettings}
        patientScreenerStatus={screenerStatus}
        prefillToken={prefillToken}
        prefillData={prefillData}
        trackerData={trackerData}
        widgetSessionOpenedTracked={widgetSessionOpenedTracked}
        scheduleRequestAttemptData={scheduleRequestAttemptData}
        setScheduleRequestAttemptData={setScheduleRequestAttemptData}
        {...props}
      />
    );
  };
  WithCustomContexts.displayName = `withCustomContexts(${componentName})`;
  WithCustomContexts.WrappedComponent = WrappedComponent;
  if (WrappedComponent.defaultProps) {
    WithCustomContexts.defaultProps = WrappedComponent.defaultProps;
  }
  hoistNonReactStatic(WithCustomContexts, WrappedComponent);

  return WithCustomContexts;
}
